
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/m/a-week-away-sneak-peek",
      function () {
        return require("private-next-pages/[locale]/m/a-week-away-sneak-peek/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/m/a-week-away-sneak-peek"])
      });
    }
  